document.addEventListener("DOMContentLoaded", function() {
  if (window.location.search.length > 0) {
    const cleanURL = window.location.origin + window.location.pathname;
    window.history.replaceState({}, document.title, cleanURL);
  }
});


// Clean Scroll Restore for Collections
document.addEventListener('DOMContentLoaded', () => {
  if (!window.location.pathname.includes('/collections/')) return;

  const key = 'scroll:' + window.location.pathname;

  // Restore scroll position when returning to the collection
  const saved = sessionStorage.getItem(key);
  if (saved) {
    requestAnimationFrame(() => window.scrollTo(0, parseInt(saved)));
  }

  // Save scroll position when clicking a product link
  document.body.addEventListener('click', e => {
    const link = e.target.closest('a');
    if (link && link.href.includes('/products/')) {
      sessionStorage.setItem(key, window.scrollY);
    }
  });
});

// Product Size Validation & Selection
document.addEventListener('DOMContentLoaded', function() {
  const sizeLabel = document.querySelector('.product-form__option-name');
  const sizeValue = document.querySelector('.product-form__option-value');
  const sizeInputs = document.querySelectorAll('input[name="option1"]');
  const addToCartBtn = document.querySelector('button.product-form__add-button');

  if (!sizeLabel || !sizeValue || sizeInputs.length === 0 || !addToCartBtn) return;

  // Reset selected size on load
sizeInputs.forEach(input => input.checked = false);
sizeValue.textContent = '';
sizeLabel.textContent = 'מידה:';
sizeLabel.style.fontWeight = '600';

 const errorMsg = document.createElement('span');
errorMsg.style.color = '#d32f2f';
errorMsg.style.marginInlineStart = '10px';
errorMsg.style.fontWeight = '600';
errorMsg.style.fontSize = '14px';
errorMsg.style.display = 'none';
errorMsg.style.whiteSpace = 'nowrap';
errorMsg.textContent = 'נא לבחור מידה';

sizeLabel.parentNode.insertBefore(errorMsg, sizeLabel.nextSibling);


  // Handle size selection
  sizeInputs.forEach(input => {
    input.addEventListener('click', function() {
      sizeValue.textContent = this.nextElementSibling.textContent;
      errorMsg.style.display = 'none';
      sizeLabel.classList.remove('size-warning');
    });
  });

  // Prevent adding to cart without selecting a size
  addToCartBtn.addEventListener('click', function(event) {
    if (!sizeValue.textContent.trim()) {
      event.preventDefault();
      errorMsg.style.display = 'inline';
      sizeLabel.classList.add('size-warning');
    }
  });
});
